import VisualPositioningManager from "./visual-positioning-manager"
import DNDComponent from "../dnd-component";

const debug = false
// const debug = "DndManager"

export default class DndManager {

    dragStarted             : boolean

    dndLayers               : any

    registeredDropTargets   : any[]
    registeredDragSources   : any[]
    draggedOver             : DNDComponent<any>[] // all items we are "over" at this moment we can have multiple e.g: in board card + cell

    lastMousePosition       : any
    dragOverTestThrottle    : any

    visualPositioningManager: VisualPositioningManager

    draggedItem?            : DNDComponent<any>
    dragStartData           : any

    constructor(options = {}) {
        debug && console.log(debug, 'constructor')

        const _options = _.assign({
            visualHorizontalDivisions: 2,
            visualVerticalDivisions: 2,
        }, options)

        this.dragStarted = false;

        this.dndLayers = {};

        this.registeredDropTargets = [];
        this.registeredDragSources = [];
        this.draggedOver = [];

        this.setDraggedItem(null);
        this.lastMousePosition = null;

        this.dragOverTestThrottle = _.throttle(this.__dragOverTest, 16);

        this.visualPositioningManager = new VisualPositioningManager(_options.visualHorizontalDivisions,_options.visualVerticalDivisions);
    }

    addWindowListeners() {
        window.addEventListener("mousemove", this.dragOverTest, true);
        window.addEventListener("mouseup", this.drop, true);

        this.visualPositioningManager.addWindowListeners();
    }

    removeWindowListeners() {
        window.removeEventListener("mousemove", this.dragOverTest, true);
        window.removeEventListener("mouseup", this.drop, true);

        this.visualPositioningManager.removeWindowListeners();
    }

    registerDndLayer(layer: any, name='default') {
        if (_.has(this.dndLayers, name)) {
            console.warn(this.constructor.name + ": layer with name " + name + " is already registered");
        } else {
            // @ts-ignore
            this.dndLayers[name] = layer;
        }
    }

    unregisterDndLayer(layer: any, name='default') {if (_.has(this.dndLayers, name)) delete this.dndLayers[name]}

    setDraggedItem(value: any) {this.draggedItem = value}

    // deprecarted
    getDraggedItem() {
        return this.draggedItem
    }

    isDraggedItem(dndId: ID) {
        return !!this.draggedItem && this.draggedItem?.getDNDId() === dndId
    }

    addDropTarget(target: any) {
        debug && console.log(debug, 'addDropTarget', target)

        this.registeredDropTargets.push(target);

        if (this.dragStarted && target.canDrop(this.getDraggedItem())) {
            this.visualPositioningManager.addTarget(target);
        }
    }

    removeDropTarget(target: any) {
        debug && console.log(debug, 'removeDropTarget', target)

        this.registeredDropTargets.remove(target);
        this.visualPositioningManager.removeTarget(target);
    }

    addDragSource(source: any) {
        // remove old one if present
        _.remove(this.registeredDragSources, registeredSource => registeredSource.getDNDId() === source.getDNDId())

        this.registeredDragSources.push(source)
        if (this.isDraggedItem(source.getDNDId())) {
            if (this.getDraggedItem()) source.copyDraggedItemPositions(this.getDraggedItem());
            this.setDraggedItem(source);
        }
    }

    removeDragSource(source: any) {
        if (this.isDraggedItem(source.getDNDId())) return
        this.registeredDragSources.remove(source)
    }

    getMousePositionDelta(e: any) {
        return {
            dx: e.clientX - this.lastMousePosition.x,
            dy: e.clientY - this.lastMousePosition.y
        };
    }

    getDraggedOver() {return this.draggedOver}

    _showPreview(item: any, mouseEvent: any) {
        _.mapKeys(this.dndLayers, (layer,key)=>{
            layer.showPreview(item, mouseEvent)
        })
    }

    _hidePreview() {_.mapKeys(this.dndLayers, (layer,key)=>{layer.hidePreview()})}
    _updatePreview(dx?: number, dy?: number) {_.mapKeys(this.dndLayers, (layer,key)=>{layer.updatePreview(dx, dy)})}

    setDragStarted = (value: boolean) => {
        this.dragStarted = value;
        gd.bus.triggerEvent('dnd-manager:drag-started', this);
    }

    dragStart(source: any, mouseEvent: any) {
        // this.dragStarted = true;
        this.lastMousePosition = {x: mouseEvent.clientX, y: mouseEvent.clientY};

        const components = _.filter(this.registeredDropTargets, t=>t.canDrop(source));
        const rectRetrievalFunction = (t: any)=>t.getDropRect();
        this.visualPositioningManager.init(components, rectRetrievalFunction);
        this.updateBlockTargets();

        this.setDraggedItem(source);
        this._showPreview(this.getDraggedItem(), mouseEvent);
        this.dragStartData = source.onDragStart();
        this.addWindowListeners();

        debug && console.log(debug, 'dragStart components', components, this.visualPositioningManager)

        this.__dragOverTest(mouseEvent); //one first immediate test
    }

    isDragging = () => this.dragStarted;

    dragOverTest = (mouseEvent: any) => {this.dragOverTestThrottle(mouseEvent);}

    updateBlockTargets = () => {this.visualPositioningManager.collectBlockTargets()}

    __isOverlapping(m: any, t: any) {
        return !(   m.clientX < t.left   ||
                    m.clientX > t.right  ||
                    m.clientY < t.top    ||
                    m.clientY > t.bottom);
    }

    //mouse position test
    private __dragOverTest(mouseEvent: any) {
        const draggedItem = this.getDraggedItem();
        if (!draggedItem) return;

        const prevDraggedOver = this.draggedOver.slice();
        let newDraggedOver: any[] = [];

        const blockTargets = this.visualPositioningManager.getAppropriateBlock(mouseEvent);

        blockTargets.map(t=>{
            const tRect = t.getDropRect();
            if (this.__isOverlapping(mouseEvent, tRect)) {
                newDraggedOver.push(t);
            }
        });
        newDraggedOver = _.orderBy(newDraggedOver, t=>t.props.dndZIndex, ['desc']); //more dndZIndex value is on top

        this.draggedOver = newDraggedOver;

        // console.log("DndManager __dragOverTest", blockTargets, newDraggedOver);

        _.difference(prevDraggedOver, newDraggedOver).map(target=>{
            if (this.registeredDropTargets.includes(target)) {
                target.onDraggedOut(this.getDraggedItem())
            }})

        _.difference(newDraggedOver, prevDraggedOver).map(target=>{
            if (this.registeredDropTargets.includes(target)) {
                target.onDraggedOver(this.getDraggedItem(), mouseEvent, this.dragStartData)
            }})

        _.map(this.draggedOver, target=>{
            if (this.registeredDropTargets.includes(target)) {
                target.onDraggingOver(this.getDraggedItem(), mouseEvent, this.dragStartData)
            }
        })

        const { dx, dy } = this.getMousePositionDelta(mouseEvent)
        this.draggedItem?.onDrag(dx, dy)
        this._updatePreview(dx, dy)
    }

    drop = (mouseEvent: any) => {
        if (!this.dragStarted || !this.draggedItem) return;
        const { dx, dy } = this.getMousePositionDelta(mouseEvent);

        this.setDragStarted(false);

        this.removeWindowListeners();
        this._hidePreview();

        // copy dragStartData...
        let dropResult : any = this.dragStartData || {}

        // // add dragged component to dropResult -
        // dropResult.draggedComponent = this.draggedItem

        // old
        // let dropResult : any = {};
        // if (this.dragStartData) dropResult = _.assign(dropResult, this.dragStartData); Yura govosir tchto neznaet zachem eto vozmozno chto bi ne bilo siilok na obekti

        this.draggedOver.map((dndComponent:DNDComponent<any>)=> {

            //
            dndComponent.onDraggedOut(this.draggedItem, true);

            dropResult = dndComponent.onDrop(this.draggedItem, dropResult);
        });

        this.draggedOver = [];
        const draggedItemId = this.draggedItem.dndId;
        this.setDraggedItem(null);
        this.lastMousePosition = null;

        const sourcesSlice : DNDComponent<any>[] = this.registeredDragSources.slice() // required in case new sources are added while processing
        _.map(sourcesSlice, (dndComponent)=> {
            if (dndComponent.dndId === draggedItemId) {
                dndComponent.onDragEnd(mouseEvent, dx, dy, dropResult);
            }
        });

        this.visualPositioningManager.flush();
    }
}